import {
    FormControl,
    MenuItem,
    OutlinedInput,
    Select,
    useMediaQuery,
} from '@material-ui/core';
import { supportedLanguages } from 'app/modules/CompanyManagement/Factories/AddEditFactory/components/utils/constant';
import { useLanguageChange } from 'app/modules/shared/hooks/useLanguageChange';
import { LanguageValues } from 'app/modules/shared/hooks/useLanguageChange/useLanguageChange.types';
import React, { memo, useCallback } from 'react';
import styles from './LanguageSwitcher.module.scss';
import { SelectEvent } from './LanguageSwitcher.types';

const LanguageSwitcher = () => {
    const isMobile = useMediaQuery('(max-width:899px)');
    const [selectedLanguage, setSelectedLanguage] = useLanguageChange();

    const onLanguageChange = useCallback(
        (e: SelectEvent) => {
            setSelectedLanguage(e.target.value as LanguageValues);
        },
        [setSelectedLanguage],
    );

    if (isMobile) {
        return null;
    }

    return (
        <FormControl fullWidth>
            <Select
                variant='outlined'
                value={selectedLanguage}
                onChange={onLanguageChange}
                id='language-switcher'
                input={
                    <OutlinedInput
                        classes={{
                            root: styles.selectRoot,
                            input: styles.selectInput,
                            notchedOutline: styles.notchedOutline,
                        }}
                    />
                }
                inputProps={{
                    classes: {
                        icon: styles.icon,
                    },
                }}
            >
                {supportedLanguages.map((language) => (
                    <MenuItem key={language.value} value={language.value}>
                        <i
                            className={`flag flag-24 flag-${language.icon.toLowerCase()}`}
                        />
                        <span className={styles.languageLabel}>
                            {language.label}
                        </span>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default memo(LanguageSwitcher);
